module.exports = __webpack_public_path__ + "img/stripe.0b0a7c2.svg";